<template>
	<CModal
		title="Error"
		:show.sync="success"
		class="disable-footer"
		centered
		fade
		color="primary"
		borderColor="primary"
		:closeOnBackdrop="false"
	>
		<center>
			<template>
				{{ resMessage }}
			</template>
			<div class="inactive-modal-response">
				<CButton
					type="submit"
					color="primary"
					class="m-1"
					@click="responseHandler"
					>Ok</CButton
				>
			</div>
		</center>
	</CModal>
</template>

<script>
export default {
	name: "Modal",
	props: {
		modal: Boolean,
		message: String,
	},
	data() {
		return {
			success: false,
			resMessage: "",
		};
	},
	watch: {
		modal() {
			this.success = this.modal;
		},
		message() {
			this.resMessage = this.message;
		},
	},

	methods: {
		responseHandler() {
			this.success = false;
			this.$emit("close");
		},
	},
};
</script>